'use es6';

import { formatToReferencesList } from 'reference-resolvers/lib/formatReferences';
import get from 'transmute/get';
export const formatSavedFilters = response => {
  return formatToReferencesList({
    getId: get('id'),
    getLabel: get('name')
  }, response.views);
};